import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-284cdffe"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "purchase-option" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "One-time purchase", -1))
const _hoisted_3 = { class: "option-price" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Subscribe", -1))
const _hoisted_5 = { class: "option-price" }
const _hoisted_6 = {
  key: 2,
  class: "box-inner-purchase-option"
}
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title" }, " Delivery Frequency ", -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Delivery monthly", -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Delivery weekly", -1))

import { IVariant, TPurchaseKind } from '@/types/product';

  interface IProps {
    variant: IVariant;
    kind: TPurchaseKind;
  }

  interface IEmits {
    (event: 'update:kind', kind: TPurchaseKind): void;
  }

  
export default /*#__PURE__*/_defineComponent({
  props: {
    variant: null,
    kind: null
  },
  emits: ["update:kind"],
  setup(__props: any, { emit: emits }: { emit: ({
    (event: 'update:kind', kind: TPurchaseKind): void;
  }), expose: any, slots: any, attrs: any }) {

  
  


return (_ctx: any,_cache: any) => {
  const _component_AppRadio = _resolveComponent("AppRadio")!
  const _component_AppPrice = _resolveComponent("AppPrice")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (['both', 'one_time_purchase'].includes(String(__props.variant.price_type)))
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: _normalizeClass(["option", { active: __props.kind === 'once' }]),
          onClick: _cache[0] || (_cache[0] = ($event: any) => (emits('update:kind', 'once')))
        }, [
          _createVNode(_component_AppRadio, {
            "model-value": __props.kind === 'once',
            class: "radio"
          }, null, 8, ["model-value"]),
          _hoisted_2,
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_component_AppPrice, {
              value: __props.variant.cost_price
            }, null, 8, ["value"])
          ])
        ], 2))
      : _createCommentVNode("", true),
    (['both', 'subscribe'].includes(String(__props.variant.price_type)))
      ? (_openBlock(), _createElementBlock("div", {
          key: 1,
          class: _normalizeClass(["option", { 'border-top': __props.variant.price_type === 'both' }]),
          onClick: _cache[1] || (_cache[1] = ($event: any) => (emits('update:kind', 'delivery_monthly')))
        }, [
          _createVNode(_component_AppRadio, {
            class: "radio",
            "model-value": ['delivery_weekly', 'delivery_monthly'].includes(__props.kind)
          }, null, 8, ["model-value"]),
          _hoisted_4,
          _createElementVNode("div", _hoisted_5, [
            _createVNode(_component_AppPrice, {
              value: __props.variant.subscribe_price
            }, null, 8, ["value"])
          ])
        ], 2))
      : _createCommentVNode("", true),
    (['delivery_weekly', 'delivery_monthly'].includes(__props.kind))
      ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
          _hoisted_7,
          _createElementVNode("div", {
            class: _normalizeClass(["inner-purchase-option", { active: __props.kind === 'delivery_monthly' }]),
            onClick: _cache[2] || (_cache[2] = ($event: any) => (emits('update:kind', 'delivery_monthly')))
          }, [
            _createVNode(_component_AppRadio, {
              class: "radio",
              "model-value": __props.kind === 'delivery_monthly'
            }, null, 8, ["model-value"]),
            _hoisted_8
          ], 2),
          _createElementVNode("div", {
            class: _normalizeClass(["inner-purchase-option", { active: __props.kind === 'delivery_weekly' }]),
            onClick: _cache[3] || (_cache[3] = ($event: any) => (emits('update:kind', 'delivery_weekly')))
          }, [
            _createVNode(_component_AppRadio, {
              class: "radio",
              "model-value": __props.kind === 'delivery_weekly'
            }, null, 8, ["model-value"]),
            _hoisted_9
          ], 2)
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})